import { Component, OnInit, AfterViewInit, ViewChild, ElementRef, ViewContainerRef, ComponentFactoryResolver } from '@angular/core';
import { RolesService } from '../roles/roles.service';
import { UsersService } from '../users/users.service';
import { ManagerReportsService } from './manager-reports.service';
import { getDataUser } from 'app/utils/helpers';
import {EventBusCardService} from '../../services/event-bus-card.service';

declare const toasr: any;
declare const $: any;

@Component({
  selector: 'app-manager-reports',
  templateUrl: './manager-reports.component.html',
  styleUrls: ['./manager-reports.component.scss']
})
export class ManagerReportsComponent implements OnInit, AfterViewInit {

  currentUser = getDataUser();
  dataDrowDown = [];
  dataTree = [];
  reportSelected: any;

  @ViewChild('treeRef') treeRef: ElementRef;
  // @ViewChild('yourComponentHost', { read: ViewContainerRef }) yourComponentHost: any;

  constructor(
    private _users: UsersService,
    private _reports: ManagerReportsService,
    private eventBus: EventBusCardService
  ) {

  }

  ngOnInit() {
    this.eventBus.pushReceived.subscribe((noti) => {
      this.getIfExistNotification();
    });
  }

  onSelected(event) {
  }

  loadAllModules() {
    return this._reports
      .getMenuReports(this.currentUser.usertypeid)
      .subscribe(
        (success) => {

          this.dataTree = this.mapForTree(success);
          this.buildTree(this.dataTree);
        },
        (err) => {
          toasr.error(err.message);
        }
    );
  }

  mapForTree(data: any) {
    const that = this;
    data.map((element) => {
      element.actions = [];
      element.text = element.data.menu.name;
      element.type = 'file';
      if (element.children) {
        if (element.children.length > 0) {
          element.type = 'folder';
          that.mapForTree(element.children);
        }
      }
    });

    return data;
  }

  buildTree(data: any) {
    var tree: any ;
    $(this.treeRef.nativeElement)
      .on('changed.jstree', (e: any, value: any) => {
        this.reportSelected = value.node.original.path;
            if (value.node.type === 'file') {
            value.instance.set_icon(value.node, 'fas fa-file-export  color-primary');
            $.each(value.instance._model.data, function (i, val) {
              if (val.type === 'file' && val.id !== value.node.id)
              {
                const node = tree.instance.get_node(val.id);
                value.instance.set_icon(node, 'fas fa-file color-primary');
               }
           });
        }


}).on('open_node.jstree', (e: any, value: any) => {
  value.instance.set_icon(value.node, 'fas fa-folder-open color-primary');
}).on('close_node.jstree', (e: any, value: any) => {
  value.instance.set_icon(value.node, 'icofont-folder');

}).on('ready.jstree', (e: any, value: any) =>  {

  tree =  value;

})
  .jstree({
    core: {
      data: data,
    },
    types : {
      folder : {
        icon : 'icofont-folder color-primary',

      },
      file : {
        icon : 'fas fa-file color-primary'
      }
    },
    plugins : [
      'types',
      // 'checkbox'
    ]
  });

}

  ngAfterViewInit() {
    this.loadAllModules();

    // const componentFactory = this._componentFactoryResolver.resolveComponentFactory(CreditsComponent);
    // const viewContainerRef = this.yourComponentHost;
    // viewContainerRef.clear();
    // const componentRef = viewContainerRef.createComponent(componentFactory);

    // const yourComponentType1Instance = (<CreditsComponent>componentRef.instance);
  }
  getIfExistNotification() {
    this.reportSelected = null;
  }
}



// WEBPACK FOOTER //
// ./src/app/pages/manager-reports/manager-reports.component.ts